<template>
    <div class="wrapper" id="pages" v-if="pages && pages.data.length">
        <ul class="list" >
            <li class="item" v-for="item in pages.data" :key="item.id">
                <welcome-pages-item class="item__inner" :page="item" :header="false" />
            </li>
        </ul>
        <archive-pages-pagination class="pagination" :paginate="pages" @current-change="changePage"/>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import WelcomePagesItem from "../welcome/WelcomePagesItem.vue";
import ArchivePagesPagination from "./ArchivePagesPagination.vue";

export default {
    name: 'ArchivePages',
    components: {
        ArchivePagesPagination,
        WelcomePagesItem,
    },
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        ...mapGetters('archive', [
            'pages',
        ]),
    },
    methods: {
        ...mapMutations('archive', [
            'setHistoricalStatusId',
        ]),
        ...mapActions('archive', [
            'getPages',
        ]),
        changePage(page) {
            this.getPages(page).then(() => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.list {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    width: 100%;
    margin: -1rem;
}
.item {
    width: calc(100% / 3 - 2rem);
    border-radius: 5px;
    border: 1px solid rgba(192, 201, 218, 0.31);
    background: #FFF;
    box-shadow: 0 40px 100px 0 rgba(195, 195, 195, 0.26);
    padding: 2rem 1.4rem 3rem 2rem;
    margin: 1rem;
    @media (max-width: 1159px) {
        flex-direction: column;
        padding: 2.4rem 1.7rem 2.5rem 2.4rem;
        min-width: calc(100% / 1);
    }
    @media (max-width: 560px) {
        padding: 2.0rem 1.8rem 5.2rem 2rem;
    }
}
.item__inner {
    height: 100%;
}
.pagination {
    width: 100%;
}
</style>
